
if(!customElements.get('ctfa-review-cards')){
 customElements.define('ctfa-review-cards',class extends HTMLElement{
  connectedCallback(){
   const setup=()=>{
    const rail=this.querySelector('.jdgm-carousel__item-container');
    const list=this.querySelector('.jdgm-carousel__item-wrapper');
    if(!rail||!list||!list.querySelector('.jdgm-carousel-item'))return false;
    if(this.dataset.ready)return true;
    this.dataset.ready='true';
    const preferred=['c405c6c1-e6c7-524f-b539-d6735ad95c96','8e138db3-e198-49b9-901a-484b8eb3f160','f29b5fbe-4850-4577-897a-d7115395460f'];
    preferred.reverse().forEach(id=>{const item=list.querySelector('[data-review-id="'+id+'"]');if(item)list.prepend(item)});
    rail.scrollLeft=0;
    rail.tabIndex=0;
    rail.setAttribute('role','region');
    rail.setAttribute('aria-label',this.querySelector('.jdgm-carousel-title')?.textContent.trim()||'Reviews');
    const controls=this.querySelector('.ctfa-review-cards__controls');
    controls.hidden=false;
    const buttons=controls.querySelectorAll('button');
    const update=()=>{buttons[0].disabled=rail.scrollLeft<=2;buttons[1].disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3};
    buttons.forEach(button=>button.addEventListener('click',()=>{const card=list.querySelector('.jdgm-carousel-item');rail.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(list).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}));
    rail.addEventListener('scroll',update,{passive:true});
    this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(rail);
    requestAnimationFrame(()=>{rail.scrollLeft=0;update()});return true;
   };
   if(!setup()){this.observer=new MutationObserver(()=>{if(setup())this.observer.disconnect()});this.observer.observe(this,{childList:true,subtree:true})}
  }
  disconnectedCallback(){this.observer?.disconnect();this.resizeObserver?.disconnect()}
 });
}
